/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgIcon } from "../shared/SvgIcon";
var PersonOutlineIcon = function PersonOutlineIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4C9.23858 4 7 6.23858 7 9C7 10.3917 7.56859 11.6506 8.48615 12.5571C5.45427 13.5517 3.04765 15.8008 2.05486 18.6734L1.72821 19.6185L3.6185 20.2718L3.94515 19.3266C4.99543 16.2877 8.16425 14 12 14C15.8358 14 19.0046 16.2877 20.0549 19.3266L20.3815 20.2718L22.2718 19.6185L21.9452 18.6734C20.9524 15.8007 18.5457 13.5517 15.5139 12.5571C16.4314 11.6506 17 10.3917 17 9C17 6.23858 14.7614 4 12 4ZM9 9C9 7.34315 10.3431 6 12 6C13.6569 6 15 7.34315 15 9C15 10.6569 13.6569 12 12 12C10.3431 12 9 10.6569 9 9Z"
  }));
};
export default PersonOutlineIcon;